import React from "react";
import "./Tolerance.css"

const Tolerance = ({tolerance}) => {
    if (!tolerance) {
        // показываем одну карточку-загрузку
        return (
            <div className="tolerance-card">
                <div className="loader-wrapper">
                    <div className="loader" />
                </div>
            </div>
        );
    }
    return (
        <div className="tolerance-card">
            <h5>Толерантность</h5>
            <p>Этаж: ±{tolerance?.floor}</p>
            <p>Площадь: ±{tolerance?.areaPercent}%</p>
            <p>Комнаты: ±{tolerance?.rooms}</p>
            <p>Расстояние: {tolerance?.distanceM} м</p>
        </div>
    )
}

export default Tolerance